import React from 'react';
import ReactDOM   from 'react-dom/client';
import './index.css'; // Optional: Import global styles
import App from './App'; // Import the main App component
// import reportWebVitals from './reportWebVitals'; // Performance reporting (optional)

const container = document.getElementById('root'); // Ensure your HTML has an element with id="root"
const root = ReactDOM.createRoot(container);

root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);

// Optional: Log web performance metrics
// Replace `console.log` with an analytics function if needed
// reportWebVitals(console.log);
